import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroupDirective, NgForm, ValidationErrors, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { GCMService } from '../../../shared/services/gcm.service';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from 'src/app/modules/shared/services/info-bar-with-status.service';
import { Profile } from 'src/app/models/Profile';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};
/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  standalone: false,
  selector: 'app-catalog-dialog',
  templateUrl: './catalog-dialog.component.html',
  styleUrls: ['./catalog-dialog.component.css']
})
export class CatalogDialogComponent implements OnInit {

  variables: any;

  matcher = new MyErrorStateMatcher();

  local_data: any;
  invalidInput1: boolean = false;
  errorMessage1: string = '';
  invalidInput2: boolean = false;
  errorMessage2: string = '';
  invalidInput3: boolean = false;
  errorMessage3: string = '';
  invalidInput4: boolean = false;
  errorMessage4: string = '';
  invalidInput5: boolean = false;
  errorMessage5: string = '';
  formGroup1: any;
  formGroup2: any;

  selected = '';
  actionSelected = '';
  complexities: any;
  editComplexities: any = [];
  filterargs = { type: this.selected }
  isEdit = false;

  filteredActions: any = [];
  filteredSubTasks: any = [];
  filteredEpics: string[] = [];
  filteredUserStories: string[] = [];

  gcms: any;

  showScale: boolean = true;

  profiles: Profile[] = [];
  centers: string[] = [];
  filteredProfiles: Profile[] = [];

  constructor(
    private GCMService: GCMService,
    public dialogRef: MatDialogRef<CatalogDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.profiles = Array.isArray(this.local_data.profiles) ? this.local_data.profiles : [];
    this.centers = [...new Set(this.profiles.map(p => p.center).filter(c => !!c))] as string[];
    this.filteredProfiles = this.profiles;
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });


    !this.local_data.actionList.find((action: any) => action.name == this.variables.other) && this.local_data.actionList.push({ 'name': this.variables.other });

    this.local_data.subTasks != null && !this.local_data.subTasks.find(
      (action: any) => action.name == this.variables.other) && this.local_data.subTasks.push({
        'name': this.variables.other
      });

    if (this.local_data.subTasks == null) {
      this.local_data.subTasks = [{ 'name': this.variables.other }]
    }

    const filteredList = this.local_data.actionList.filter((action: any) => action.name !== this.variables.other);

    filteredList.push({ name: this.variables.other });

    filteredList.sort((a: any, b: any) => {
      if (a.name === this.variables.other) return 1;
      if (b.name === this.variables.other) return -1;
      return a.name.localeCompare(b.name);
    });

    this.local_data.actionList = filteredList;

    if (this.local_data.element !== undefined) this.isEdit = true;

    if (this.isEdit) {

      if (this.local_data.type == "EDIT_OTHER") {
        const element = this.local_data.element;

        let subTask = this.variables.other;
        let action = this.variables.other;

        if (element.complexityLevel != this.variables.notApplic) {
          const complex = this.local_data.actionList.filter((action: any) => {
            return action.name === this.local_data.element.task;
          })

          if (complex.length > 0) {
            this.editComplexities = [
              { complex: '1', name: this.variables.low1 + ' - ' + complex[0].complexityLow + ' ' + this.variables.hours },
              { complex: '2', name: this.variables.medium1 + ' - ' + complex[0].complexityMedium + ' ' + this.variables.hours },
              { complex: '3', name: this.variables.high1 + ' - ' + complex[0].complexityHigh + ' ' + this.variables.hours },
            ]

            action = element.task;
          }
        }

        if (!this.local_data.subTasks.some((activity: any) => activity.name == element.subTask)) {
          subTask = this.variables.other;
        }

        this.formGroup1 = this._formBuilder.group({
          activityCtrl: [subTask, Validators.required],
          actionCtrl: [action, Validators.required],
          actionFilterCtrl: new FormControl(),
          activityFilterCtrl: new FormControl(),
          actionOtherCtrl: [element.task, action == this.variables.other ? Validators.required : null],
          activityOtherCtrl: [element.subTask, subTask == this.variables.other ? Validators.required : null],
          complexityCtrl: [element.complexityLevel, action != this.variables.other ? Validators.required : null],
          effortOtherCtrl: [action == this.variables.other ? element.complexity / element.itemCount : null, action == this.variables.other ? Validators.required : null],
          itemsCtrl: [
            element.itemCount,
            [Validators.required, this.customValidator.bind(this), this.noDecimalValidator],
          ],
          centerCtrl: [''],
          profileCtrl: [element.profileId || ''],
        });

        // Pre-select center based on element's profileId
        const existingProfile = this.profiles.find(p => p.id === element.profileId);
        if (existingProfile?.center) {
          this.formGroup1.get('centerCtrl')?.setValue(existingProfile.center);
          this.filteredProfiles = this.profiles.filter(p => p.center === existingProfile.center);
        }

        //this.formGroup1.get("actionCtrl").updateValueAndValidity({ emitEvent: true });
      }
      else if (this.local_data.type == "EDIT_AGILE") {
        const element = this.local_data.element;

        let action;
        let subTask;

        if (this.local_data.estimateMode == 'complex') {
          const complex = this.local_data.actionList.filter((action: any) => {
            return action.name === this.local_data.element.task;
          })

          if (complex.length > 0) {
            this.editComplexities = [
              { complex: '1', name: this.variables.low1 + ' - ' + complex[0].complexityLow.toFixed(2) + ' ' + this.variables.hours },
              { complex: '2', name: this.variables.medium1 + ' - ' + complex[0].complexityMedium.toFixed(2) + ' ' + this.variables.hours },
              { complex: '3', name: this.variables.high1 + ' - ' + complex[0].complexityHigh.toFixed(2) + ' ' + this.variables.hours },
            ]

            action = element.task;
          }
          else {
            action = this.variables.other;
          }

          if (!this.local_data.subTasks.some((activity: any) => activity.name == element.subTask)) {
            subTask = this.variables.other;
          }
          else {
            subTask = element.subTask;
          }
        }

        this.complexities = this.local_data.element

        if (this.local_data.estimateMode == 'tshirt') {
          const complexs = this.local_data.actionList.filter((dataItem: any) => {
            return dataItem.name === this.local_data.element.task;
          });

          action = this.variables.other;
          if (complexs.length > 0) {
            this.complexities = complexs[0];

            action = element.task;
          }

          if (!this.local_data.subTasks.some((activity: any) => activity.name == element.subTask)) {
            subTask = this.variables.other;
          }
          else {
            subTask = element.subTask;
          }
        }

        this.formGroup2 = this._formBuilder.group({
          epicCtrl: [element.epic, Validators.required],
          userStoryCtrl: [element.userStory, Validators.required],
          taskCtrl: [action, Validators.required],
          taskOtherCtrl: [element.task, action == this.variables.other ? Validators.required : null],
          taskFilterCtrl: [''],
          subTaskCtrl: [subTask, Validators.required],
          subTaskOtherCtrl: [element.subTask, action == this.variables.other ? Validators.required : null],
          subTaskFilterCtrl: [''],
          complexityCtrl: [element.complexityLevel],
          complexityOtherCtrl: [element.complexity, action == this.variables.other ? Validators.required : null],
          tshirtScaleCtrl: [element.tshirtScaleLevel],
          tshirtScaleFilterCtrl: [''],
          tshirtOtherScaleCtrl: [action == this.variables.other ? element.complexity / 8 : '', action == this.variables.other ? Validators.required : null],
          itemsCtrl: [
            element.itemCount,
            [Validators.required, this.customValidator.bind(this), this.noDecimalValidator],
          ],
          centerCtrl: [''],
          profileCtrl: [element.profileId || ''],
        })

        // Pre-select center based on element's profileId
        const existingProfileAgile = this.profiles.find(p => p.id === element.profileId);
        if (existingProfileAgile?.center) {
          this.formGroup2.get('centerCtrl')?.setValue(existingProfileAgile.center);
          this.filteredProfiles = this.profiles.filter(p => p.center === existingProfileAgile.center);
        }

      }
    } else {

      this.formGroup1 = this._formBuilder.group({
        activityCtrl: ['', Validators.required],
        actionCtrl: ['', Validators.required],
        actionFilterCtrl: new FormControl(),
        activityFilterCtrl: new FormControl(),
        actionOtherCtrl: ['', Validators.required],
        activityOtherCtrl: ['', Validators.required],
        complexityCtrl: [],
        effortOtherCtrl: [],
        itemsCtrl: [
          null,
          [Validators.required, this.customValidator.bind(this), this.noDecimalValidator],
        ],
        centerCtrl: [''],
        profileCtrl: [''],
        //gcmCtrl: ['', Validators.required]
      });

      this.formGroup2 = this._formBuilder.group({
        epicCtrl: ['', Validators.required],
        userStoryCtrl: ['', Validators.required],
        taskCtrl: ['', Validators.required],
        taskOtherCtrl: [''],
        taskFilterCtrl: [''],
        subTaskCtrl: ['', Validators.required],
        subTaskOtherCtrl: [''],
        subTaskFilterCtrl: [''],
        complexityCtrl: [''],
        complexityOtherCtrl: ['', [Validators.pattern(/^\d+((\.\d{1,2})?)|(\.)$/)]],
        tshirtScaleCtrl: [''],
        tshirtScaleFilterCtrl: [''],
        tshirtOtherScaleCtrl: [''],
        itemsCtrl: [
          '',
          [Validators.required, this.customValidator.bind(this), this.noDecimalValidator],
        ],
        centerCtrl: [''],
        profileCtrl: [''],
      })
    }


    this.filteredActions = this.local_data.actionList.slice();
    this.filteredSubTasks = this.local_data.subTasks.slice();

    // Listas únicas de épicas e historias de usuario ya utilizadas (si vienen del componente padre)
    const existingEpics: string[] = (this.local_data.existingEpics || []) as string[];
    const existingUserStories: string[] = (this.local_data.existingUserStories || []) as string[];

    this.filteredEpics = existingEpics.slice();
    this.filteredUserStories = existingUserStories.slice();

    this.local_data.metodology != 'agile' && this.actionChange();
    this.local_data.metodology == 'agile' && this.actionChangeAgile();
    this.local_data.metodology != 'agile' && this.activityChange();
    this.local_data.metodology == 'agile' && this.activityChangeAgile();
    //this.local_data.metodology != 'agile' && this.applyActionValidators(this.formGroup1.get('actionCtrl')?.value);
    //this.local_data.metodology != 'agile' && this.applyActivityValidators(this.formGroup1.get('activityCtrl')?.value);
    //this.local_data.metodology == 'agile' && this.estimateModeChange()

    if (this.local_data.metodology == 'agile' && this.local_data.estimateMode == 'tshirt') {
      this.filteredActions = this.filteredActions.filter((item: any) => item.tshirtXS && item.tshirtS && item.tshirtM && item.tshirtL && item.tshirtXL && item.tshirtXXL).slice();
    }

    this.local_data.metodology != 'agile' && this.formGroup1.get('actionFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterActions(value);
    });

    this.local_data.metodology != 'agile' && this.formGroup1.get('activityFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterSubTaks(value);
    });

    this.local_data.metodology == 'agile' && this.formGroup2.get('taskFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterActions(value);
    });

    this.local_data.metodology == 'agile' && this.formGroup2.get('subTaskFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterSubTaks(value);
    });

    this.local_data.metodology == 'agile' && this.formGroup2.get('tshirtScaleFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterSubTaks(value);
    });

    // Autocompletado de épicas e historias de usuario en modo agile
    this.local_data.metodology == 'agile' && this.formGroup2.get('epicCtrl').valueChanges.subscribe((value: any) => {
      this.filterEpics(value);
    });

    this.local_data.metodology == 'agile' && this.formGroup2.get('userStoryCtrl').valueChanges.subscribe((value: any) => {
      this.filterUserStories(value);
    });
  }

  filterActions(value: string) {
    if (!this.local_data) {
      return;
    }
    let search = value;
    if (!search) {
      this.filteredActions = this.local_data.actionList.slice();
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredActions = this.local_data.actionList.filter((action: any) => action.name.toLowerCase().indexOf(search) > -1);
  }

  filterSubTaks(value: string) {
    if (!this.local_data) {
      return;
    }
    let search = value;
    if (!search) {
      this.filteredSubTasks = this.local_data.subTasks.slice();
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredSubTasks = this.local_data.subTasks.filter((action: any) => action.name.toLowerCase().indexOf(search) > -1);
  }

  filterEpics(value: string) {
    const allEpics: string[] = (this.local_data.existingEpics || []) as string[];
    if (!allEpics) {
      return;
    }
    let search = value;
    if (!search) {
      this.filteredEpics = allEpics.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredEpics = allEpics.filter((epic: string) => epic.toLowerCase().indexOf(search) > -1);
  }

  filterUserStories(value: string) {
    const allUserStories: string[] = (this.local_data.existingUserStories || []) as string[];
    if (!allUserStories) {
      return;
    }
    let search = value;
    if (!search) {
      this.filteredUserStories = allUserStories.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredUserStories = allUserStories.filter((us: string) => us.toLowerCase().indexOf(search) > -1);
  }

  noDecimalValidator(control: any): ValidationErrors | null {
    const value = control.value;
    if (value != null && value % 1 !== 0) {
      return { decimal: true };
    }
    return null;
  }

  handleInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = parseFloat(inputElement.value);
    if (isNaN(value) || value < 0) {
      value = 0; // Set value to 0 if it's negative or NaN
    }
    inputElement.value = value.toString(); // Update input field value
  }

  customValidator(control: any) {
    const value = control.value;
    if (value <= 0) {
      return { 'invalidValue': true };
    }
    return null;
  }

  private isKnownAction(value: string): boolean {
    return !!value && this.local_data?.actionList?.some((item: any) => item.name === value);
  }

  private isKnownSubTask(value: string): boolean {
    return !!value && this.local_data?.subTasks?.some((item: any) => item.name === value);
  }

  private normalizeOtherSelections(): void {
    const actionCtrl = this.formGroup1?.get('actionCtrl');
    const activityCtrl = this.formGroup1?.get('activityCtrl');
    const actionOtherCtrl = this.formGroup1?.get('actionOtherCtrl');
    const activityOtherCtrl = this.formGroup1?.get('activityOtherCtrl');

    const actionValue = actionCtrl?.value;
    const activityValue = activityCtrl?.value;

    if (actionValue && actionValue !== this.variables.other && !this.isKnownAction(actionValue)) {
      actionOtherCtrl?.setValue(actionValue);
      actionCtrl?.setValue(this.variables.other);
    }

    if (activityValue && activityValue !== this.variables.other && !this.isKnownSubTask(activityValue)) {
      activityOtherCtrl?.setValue(activityValue);
      activityCtrl?.setValue(this.variables.other);
    }
  }

  private applyActionValidators(result: any): void {
    if (result == this.variables.other) {
      this.formGroup1.get('complexityCtrl').clearValidators();
      this.formGroup1.get('complexityCtrl').setErrors(null);
      this.formGroup1.get('complexityCtrl').updateValueAndValidity({ emitEvent: false });
      this.formGroup1.get('actionOtherCtrl').setValidators(Validators.required);
      this.formGroup1.get('actionOtherCtrl').updateValueAndValidity({ emitEvent: false });
      this.formGroup1.get('effortOtherCtrl').setValidators(Validators.required);
      this.formGroup1.get('effortOtherCtrl').updateValueAndValidity({ emitEvent: false });
    }
    else {
      this.formGroup1.get('effortOtherCtrl').clearValidators();
      this.formGroup1.get('effortOtherCtrl').setErrors(null);
      this.formGroup1.get('effortOtherCtrl').updateValueAndValidity({ emitEvent: false });
      this.formGroup1.get('actionOtherCtrl').clearValidators();
      this.formGroup1.get('actionOtherCtrl').setErrors(null);
      this.formGroup1.get('actionOtherCtrl').updateValueAndValidity({ emitEvent: false });
      this.formGroup1.get('complexityCtrl').setValidators(Validators.required);
      this.formGroup1.get('complexityCtrl').updateValueAndValidity({ emitEvent: false });
    }

    const complexs = this.local_data.actionList.filter((dataItem: any) => {
      return dataItem.name === result;
    });
    this.complexities = complexs[0];

    if (result !== this.variables.other && complexs[0]?.profileId) {
      const taskProfile = this.profiles.find(p => p.id === complexs[0].profileId);
      if (taskProfile) {
        if (taskProfile.center) {
          this.formGroup1.get('centerCtrl')?.setValue(taskProfile.center);
          this.filteredProfiles = this.profiles.filter(p => p.center === taskProfile.center);
        }
        this.formGroup1.get('profileCtrl')?.setValue(taskProfile.id);
      }
    } else if (result === this.variables.other) {
      this.formGroup1.get('centerCtrl')?.setValue('');
      this.formGroup1.get('profileCtrl')?.setValue('');
      this.filteredProfiles = this.profiles;
    }
  }

  private applyActivityValidators(result: any): void {
    if (result == this.variables.other) {
      this.formGroup1.get('activityOtherCtrl').setValidators(Validators.required);
      this.formGroup1.get('activityOtherCtrl').updateValueAndValidity({ emitEvent: false });
    }
    else {
      this.formGroup1.get('activityOtherCtrl').clearValidators();
      this.formGroup1.get('activityOtherCtrl').setErrors(null);
      this.formGroup1.get('activityOtherCtrl').updateValueAndValidity({ emitEvent: false });
      this.formGroup1.get('activityOtherCtrl')?.reset();
    }
  }

  actionChange() {
    this.formGroup1.get("actionCtrl").valueChanges.subscribe((result: any) => {
      this.applyActionValidators(result);
    })
  }

  actionChangeAgile() {
    this.formGroup2.get("taskCtrl").valueChanges.subscribe((result: any) => {
      if (result == this.variables.other) {

        this.formGroup2.get('taskOtherCtrl').setValidators(Validators.required);
        this.formGroup2.get('taskOtherCtrl').updateValueAndValidity();

        this.formGroup2.get('complexityCtrl').clearValidators();
        this.formGroup2.get('complexityCtrl').updateValueAndValidity();

        this.formGroup2.get('tshirtScaleCtrl').clearValidators();
        this.formGroup2.get('tshirtScaleCtrl').updateValueAndValidity();

        if (this.local_data.estimateMode == 'complex') {
          this.formGroup2.get('complexityOtherCtrl').setValidators(Validators.required);
          this.formGroup2.get('complexityOtherCtrl').updateValueAndValidity();

          this.formGroup2.get('tshirtOtherScaleCtrl').clearValidators();
          this.formGroup2.get('tshirtOtherScaleCtrl').updateValueAndValidity();

        }
        else if (this.local_data.estimateMode == 'tshirt') {
          this.formGroup2.get('tshirtOtherScaleCtrl').setValidators(Validators.required);
          this.formGroup2.get('tshirtOtherScaleCtrl').updateValueAndValidity();

          this.formGroup2.get('complexityOtherCtrl').clearValidators();
          this.formGroup2.get('complexityOtherCtrl').updateValueAndValidity();

        }
      }
      else {

        this.formGroup2.get('complexityOtherCtrl').clearValidators();
        this.formGroup2.get('complexityOtherCtrl').updateValueAndValidity();

        this.formGroup2.get('tshirtOtherScaleCtrl').clearValidators();
        this.formGroup2.get('tshirtOtherScaleCtrl').updateValueAndValidity()

        if (this.local_data.estimateMode == 'complex') {
          this.formGroup2.get('complexityCtrl').setValidators(Validators.required);
          this.formGroup2.get('complexityCtrl').updateValueAndValidity();

          this.formGroup2.get('tshirtScaleCtrl').clearValidators();
          this.formGroup2.get('tshirtScaleCtrl').updateValueAndValidity();
        }
        else if (this.local_data.estimateMode == 'tshirt') {

          this.formGroup2.get('tshirtScaleCtrl').setValidators(Validators.required);
          this.formGroup2.get('tshirtScaleCtrl').updateValueAndValidity();

          this.formGroup2.get('complexityCtrl').clearValidators();
          this.formGroup2.get('complexityCtrl').updateValueAndValidity();
        }
      }
      const complexs = this.local_data.actionList.filter((dataItem: any) => {
        return dataItem.name === result;
      });
      this.complexities = complexs[0];

      // Auto-fill profile from catalog task
      if (result !== this.variables.other && complexs[0]?.profileId) {
        const taskProfile = this.profiles.find(p => p.id === complexs[0].profileId);
        if (taskProfile) {
          if (taskProfile.center) {
            this.formGroup2.get('centerCtrl')?.setValue(taskProfile.center);
            this.filteredProfiles = this.profiles.filter(p => p.center === taskProfile.center);
          }
          this.formGroup2.get('profileCtrl')?.setValue(taskProfile.id);
        }
      } else if (result === this.variables.other) {
        this.formGroup2.get('centerCtrl')?.setValue('');
        this.formGroup2.get('profileCtrl')?.setValue('');
        this.filteredProfiles = this.profiles;
      }
    })

  }

  estimateModeChange() {
    this.formGroup2.get("estimateModeCtrl").valueChanges.subscribe((result: any) => {
      if (this.isEdit) {
        const complex = this.local_data.actionList.filter((action: any) => {
          return action.name === this.local_data.element.task;
        })

        if (result == 1) {
          this.editComplexities = [
            { complex: '1', name: this.variables.low1 + ' - ' + complex[0].complexityLow.toFixed(2) + ' ' + this.variables.hours },
            { complex: '2', name: this.variables.medium1 + ' - ' + complex[0].complexityMedium.toFixed(2) + ' ' + this.variables.hours },
            { complex: '3', name: this.variables.high1 + ' - ' + complex[0].complexityHigh.toFixed(2) + ' ' + this.variables.hours },
          ]
        }
        else if (result == 2) {
          this.complexities = complex[0];
        }
      }

      if (result == 1) { //Complexity Mode
        if (this.formGroup2.get("taskCtrl").value == this.variables.other) {

          this.formGroup2.get('complexityOtherCtrl').setValidators(Validators.required);
          this.formGroup2.get('complexityOtherCtrl').updateValueAndValidity();

          this.formGroup2.get('complexityCtrl').clearValidators();
          this.formGroup2.get('complexityCtrl').updateValueAndValidity();
          this.formGroup2.get('complexityCtrl')?.reset();

        }
        else if (this.formGroup2.get("taskCtrl").value != this.variables.other) {
          this.formGroup2.get('complexityOtherCtrl').clearValidators();
          this.formGroup2.get('complexityOtherCtrl').updateValueAndValidity();
          this.formGroup2.get('complexityOtherCtrl')?.reset();

          this.formGroup2.get('complexityCtrl').setValidators(Validators.required);
          this.formGroup2.get('complexityCtrl').updateValueAndValidity();
        }
        this.formGroup2.get('tshirtOtherScaleCtrl').clearValidators();
        this.formGroup2.get('tshirtOtherScaleCtrl').updateValueAndValidity();

        this.formGroup2.get('tshirtScaleCtrl').clearValidators();
        this.formGroup2.get('tshirtScaleCtrl').updateValueAndValidity();
        this.formGroup2.get('tshirtScaleCtrl')?.reset();
      }
      else if (result == 2) { //Agile Mode
        if (this.formGroup2.get("taskCtrl").value == this.variables.other) {

          this.formGroup2.get('tshirtOtherScaleCtrl').setValidators(Validators.required);
          this.formGroup2.get('tshirtOtherScaleCtrl').updateValueAndValidity();

          this.formGroup2.get('tshirtScaleCtrl').clearValidators();
          this.formGroup2.get('tshirtScaleCtrl').updateValueAndValidity();
          this.formGroup2.get('tshirtScaleCtrl')?.reset();

        }
        else if (this.formGroup2.get("taskCtrl").value != this.variables.other) {
          this.formGroup2.get('tshirtOtherScaleCtrl').clearValidators();
          this.formGroup2.get('tshirtOtherScaleCtrl').updateValueAndValidity();
          this.formGroup2.get('tshirtOtherScaleCtrl')?.reset();

          this.formGroup2.get('tshirtScaleCtrl').setValidators(Validators.required);
          this.formGroup2.get('tshirtScaleCtrl').updateValueAndValidity();

        }
        this.formGroup2.get('complexityOtherCtrl').clearValidators();
        this.formGroup2.get('complexityOtherCtrl').updateValueAndValidity();
        this.formGroup2.get('complexityOtherCtrl')?.reset();

        this.formGroup2.get('complexityCtrl').clearValidators();
        this.formGroup2.get('complexityCtrl').updateValueAndValidity();
        this.formGroup2.get('complexityCtrl')?.reset();
      }
    });
  }

  activityChange() {
    this.formGroup1.get("activityCtrl").valueChanges.subscribe((result: any) => {
      this.applyActivityValidators(result);
    });
  }

  activityChangeAgile() {
    this.formGroup2.get("subTaskCtrl").valueChanges.subscribe((result: any) => {
      if (result == this.variables.other) {
        this.formGroup2.get('subTaskOtherCtrl').setValidators(Validators.required);
        this.formGroup2.get('subTaskOtherCtrl').updateValueAndValidity();
      }
      else {
        this.formGroup2.get('subTaskOtherCtrl').clearValidators();
        this.formGroup2.get('subTaskOtherCtrl').updateValueAndValidity();
        this.formGroup2.get('subTaskOtherCtrl')?.reset();
      }
    });
  }

  doAction() {
    //this.normalizeOtherSelections();
    //this.formGroup1.updateValueAndValidity();

    this.formGroup1.get('itemsCtrl').markAsTouched();
    this.formGroup1.get('actionCtrl').markAsTouched();
    this.formGroup1.get('actionCtrl').value == this.variables.other && this.formGroup1.get('actionOtherCtrl').markAsTouched();
    this.formGroup1.get('actionCtrl').value == this.variables.other && this.formGroup1.get('effortOtherCtrl').markAsTouched();
    this.formGroup1.get('activityCtrl').markAsTouched();
    this.formGroup1.get('activityCtrl').value == this.variables.other && this.formGroup1.get('activityOtherCtrl').markAsTouched();
    this.formGroup1.get('complexityCtrl').markAsTouched();
    this.formGroup1.get('effortOtherCtrl').markAsTouched();
    //this.formGroup1.get('gcmCtrl').markAsTouched();

    const effortOther = this.formGroup1.value.effortOtherCtrl;
    const items = this.formGroup1.value.itemsCtrl;

    // Find the selected action
    let action: any;
    let actionName;
    let complexityValue;
    let complexityLevel;
    //let gcm;
    this.local_data.actionList.forEach((element: any) => {
      if (element.name === this.formGroup1.value.actionCtrl) {
        action = element;
      }
    });
    // Define the complexity value of the action based on the complexity level
    if (action.name != this.variables.other) {
      complexityLevel = this.formGroup1.value.complexityCtrl.toString();
      actionName = this.formGroup1.value.actionCtrl;
      if (complexityLevel === '1') complexityValue = action.complexityLow.toFixed(2);
      if (complexityLevel === '2') complexityValue = action.complexityMedium.toFixed(2);
      if (complexityLevel === '3') complexityValue = action.complexityHigh.toFixed(2);
    }
    else {
      actionName = this.formGroup1.value.actionOtherCtrl
      complexityLevel = null;
      complexityValue = this.formGroup1.value.effortOtherCtrl;
    }

    //gcm = this.gcms.find((item:any) => item.gcm == this.formGroup1.value.gcmCtrl);
    // Prepare result to be passed back to the component
    const result = {
      subTask: this.formGroup1.value.activityCtrl == this.variables.other ? this.formGroup1.value.activityOtherCtrl : this.formGroup1.value.activityCtrl,
      task: actionName,
      complexityLevel: complexityLevel,
      complexity: complexityValue * items,
      itemCount: items,
      //gcm: gcm
      gcm: 0,
      tool: null,
      profileId: this.formGroup1.value.profileCtrl || null
    }


    // Pass data
    if (this.formGroup1.status === 'VALID') {
      this.dialogRef.close({ data: result });
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 3000);

    };

  }

  submitAgileForm() {
    this.formGroup2.get('epicCtrl').markAsTouched();
    this.formGroup2.get('userStoryCtrl').markAsTouched();
    this.formGroup2.get('taskCtrl').markAsTouched();
    this.formGroup2.get('taskOtherCtrl').markAsTouched();
    this.formGroup2.get('subTaskCtrl').markAsTouched();
    this.formGroup2.get('subTaskOtherCtrl').markAsTouched();
    this.formGroup2.get('complexityCtrl').markAsTouched();
    this.formGroup2.get('complexityOtherCtrl').markAsTouched();
    this.formGroup2.get('tshirtScaleCtrl').markAsTouched();
    this.formGroup2.get('tshirtOtherScaleCtrl').markAsTouched();
    this.formGroup2.get('itemsCtrl').markAsTouched();

    if (this.formGroup2.valid) {

      let task: any;

      this.local_data.actionList.forEach((element: any) => {
        if (element.name === this.formGroup2.value.taskCtrl) {
          task = element;
        }
      });


      const subTask = {
        epic: this.formGroup2.get('epicCtrl').value,
        userStory: this.formGroup2.get('userStoryCtrl').value,
        task: this.formGroup2.get('taskCtrl').value == this.variables.other ? this.formGroup2.get('taskOtherCtrl').value : this.formGroup2.get('taskCtrl').value,
        subTask: this.formGroup2.get('subTaskCtrl').value == this.variables.other ? this.formGroup2.get('subTaskOtherCtrl').value : this.formGroup2.get('subTaskCtrl').value,
        complexityLevel: this.local_data.estimateMode == 'tshirt' ? null : this.formGroup2.get('taskCtrl').value == this.variables.other ? null : this.formGroup2.get('complexityCtrl').value.toString(),
        complexity: this.roundToTwoDecimalPlaces(this.local_data.estimateMode == 'complex' && this.formGroup2.get('taskCtrl').value != this.variables.other ?
          this.getComplexity(task) * this.formGroup2.get('itemsCtrl').value :
          this.local_data.estimateMode == 'complex' && this.formGroup2.get('taskCtrl').value == this.variables.other ?
            this.formGroup2.get('complexityOtherCtrl').value * this.formGroup2.get('itemsCtrl').value :
            this.local_data.estimateMode == 'tshirt' && this.formGroup2.get('taskCtrl').value != this.variables.other ?
              this.getTshirtEffort(task) * 8 * this.formGroup2.get('itemsCtrl').value :
              this.formGroup2.get('tshirtOtherScaleCtrl').value * 8 * this.formGroup2.get('itemsCtrl').value),
        tshirtScaleLevel: this.local_data.estimateMode == 'complex' ? null : this.formGroup2.get('taskCtrl').value == this.variables.other ? null : this.formGroup2.get('tshirtScaleCtrl').value,
        itemCount: this.formGroup2.get('itemsCtrl').value,
        tool: null,
        profileId: this.formGroup2.value.profileCtrl || null
      }
      this.dialogRef.close({ data: subTask });
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 3000);
    };
  }

  getComplexity(task: any) {
    let complexityValue = 0;
    let complexityLevel = this.formGroup2.get('complexityCtrl').value.toString();
    if (complexityLevel === '1') complexityValue = task.complexityLow.toFixed(2);
    if (complexityLevel === '2') complexityValue = task.complexityMedium.toFixed(2);
    if (complexityLevel === '3') complexityValue = task.complexityHigh.toFixed(2);
    return complexityValue;
  }

  roundToTwoDecimalPlaces(num: number): number {
    return Math.round(num * 100) / 100;
  }

  getTshirtEffort(task: any) {
    let complexityLevel = this.formGroup2.get('tshirtScaleCtrl').value;
    switch (complexityLevel) {
      case 'XS':
        return task.tshirtXS
      case 'S':
        return task.tshirtS
      case 'M':
        return task.tshirtM
      case 'L':
        return task.tshirtL
      case 'XL':
        return task.tshirtXL
      case 'XXL':
        return task.tshirtXXL
      default:
        return 0
    }
  }

  isControlRequired(controlName: string): boolean {
    const control = this.formGroup2.get(controlName);
    if (control && control.validator) {
      const validator = control.validator({} as FormControl);
      return validator && validator.required;
    }
    return false;
  }

  getDescription(desc: string) {
    return this.variables.complexityDescription + ':\n' + desc;
  }

  onCenterChange(center: string): void {
    if (center) {
      this.filteredProfiles = this.profiles.filter(p => p.center === center);
    } else {
      this.filteredProfiles = this.profiles;
    }
    // Reset profile selection when center changes
    const activeForm = this.local_data.metodology === 'agile' ? this.formGroup2 : this.formGroup1;
    activeForm?.get('profileCtrl')?.setValue('');
  }

}
